import { computed } from 'vue';
import { brand } from 'config';
import useGridItemWidth from './useGridItemWidth';
import { Ref, ComputedRef, SkeletonItems } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

const approxContentHeight = 169;
const aspectRatio = brand === 'mcom' ? 0.82 : 0.8;

/**
 *
 * @param {Ref<HTMLElement>} gridEl
 * @param {ComputedRef<number>} loadingItemsRef
 * @returns {SkeletonItems}
 */
export default function useSkeletonItems(gridEl, loadingItemsRef) {
  const { gridItemWidth } = useGridItemWidth(gridEl);
  const imgHeight = computed(() => Math.round(gridItemWidth.value / aspectRatio));
  const skeletonHeight = computed(() => `${imgHeight.value + approxContentHeight}px`);
  const skeletonItems = computed(() => new Array(loadingItemsRef.value).map((_, index) => index));

  return {
    skeletonHeight, skeletonItems,
  };
}
